import { Box, InputAdornment, Stack, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardIcon, farmers, region, userManagement } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";
import translations from "../../config/language";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getUser } from "../../config/services";
import { useSelector } from "react-redux";
import { notifyError } from "../../config/ToastMessage";

const UserManagement = () => {
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page')) || 1;
  });
  const [count, setCount] = useState();
  const [getUserData, setGetUserData] = useState([]);

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "User Management" && module.is_editor === true
  ) ? true : false;
  const handleChange = (event, value) => {
    setCurrentPage(value);
    const url = new URL(window.location.href);
    url.searchParams.set('page', value);
    window.history.pushState({}, '', url);
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page')) || 1;
    setCurrentPage(page);
  }, [window.location.search]);
  useEffect(() => {
    handlegetUserAPIData();
  }, [currentPage, debounceSearchText])
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes
  const handlegetUserAPIData = async () => {
    const data = { search: debounceSearchText }
    try {
      const resp = await getUser(data, currentPage, perPage);
      if (resp.status === 200 || resp.status === 201) {
        setGetUserData(resp.data.results.payload);
        setCount(resp.data.count);
      }
    }
    catch (err) {
      setGetUserData([])
    }
  }

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const navigate = useNavigate();
  const language = process.env.REACT_APP_LANGUAGE;

  // in state want to send the action is view or edit 
  const handleVisibilityClick = (id, status) => {
    navigate(`/user-management/user-management-detail/${id}?page=${currentPage}`, { state: { action: "view", status: `${status}` } });
  };

  return (
    <>
      <Box className="task-assign-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={userManagement.userManagementIcon}
              alt=""
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].userManagement}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="crop-table-container">
          <Table className="region-table pt-1" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{translations[language].srNo}</TableCell>
                <TableCell>{translations[language].photo}</TableCell>
                <TableCell>{translations[language].name}</TableCell>
                <TableCell>{translations[language].role}</TableCell>
                <TableCell>{translations[language].gender}</TableCell>
                <TableCell>{translations[language].mobileNumber}</TableCell>
                <TableCell>{translations[language].email}</TableCell>
                <TableCell>{translations[language].statusView}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getUserData?.length > 0 ? getUserData?.map((e, i) => {
                return (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }}>{i + 1 + (currentPage - 1) * perPage}</TableCell>
                    <TableCell>{e.profile_photo ? <img
                      src={e.profile_photo}
                      alt=""
                      className="farmer-photo"
                    /> : <img
                      src={dashboardIcon.profileImage}
                      alt=""
                      className="farmer-photo"
                    />}</TableCell>
                    <TableCell>{e.first_name} {e.last_name}</TableCell>
                    <TableCell>{e.role_name}</TableCell>
                    <TableCell>{e.gender == "0" ? "Male" : e.gender == "1" ? "Female" : ""}</TableCell>
                    <TableCell>{e.mobile_number}</TableCell>
                    <TableCell style={{
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>{e.email}</TableCell>
                    <TableCell style={{ width: "50px" }}>
                      <div className="d-flex gap-4 justify-content-end">
                        {/* <div style={{
                          color: e.is_active ? "#31A05F" : e.pending ? "#FF0000" : ""
                        }}>
                          {e.pending ? "Pending" : e.is_active ? "Active" : "Inactive"}
                        </div> */}
                        {/* {i % 3 === 0 ? (
                          <div style={{ color: "#FF0000" }}>Pending</div>
                        ) : i % 3 === 1 ? (
                          <div style={{ color: "#31A05F" }}>Active</div>
                        ) : (
                          <div>Inactive</div>
                        )} */}
                        <div style={{
                          color: e.status === 12 ? "#FF0000" : e.is_active ? "#31A05F" : ""
                        }}>
                          {e.status === 12 ? "Pending" : e.is_active ? "Active" : "Inactive"}
                        </div>

                        <div className="d-flex gap-3">
                          <img
                            src={region.editIcon}
                            alt=""
                            onClick={() => {
                              if (!isAccess) {
                                notifyError(translations[language].youDontHaveAccess);
                                return;
                              }
                              navigate(`/user-management/user-management-detail/${e.id}?page=${currentPage}`, { state: { action: "edit", status: e.status === 12 ? "pending" : e.is_active ? "active" : "inactive" } })
                            }
                            }
                            style={{ cursor: "pointer", height: "20px", width: "20px" }}
                          />
                          <VisibilityIcon
                            onClick={() => handleVisibilityClick(e.id,e.status === 12 ? "pending" : e.is_active ? "active" : "inactive")}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              }) : <TableRow>
                <TableCell colSpan={8} style={{ textAlign: "center" }}>
                  <img src={farmers.noData} alt="No Data" />
                </TableCell>
              </TableRow>}
            </TableBody>
          </Table>
        </Box>
        <Box display="flex" justifyContent="end" alignItems="center" className="pagination">
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default UserManagement;
